module.exports = __webpack_public_path__ + "img/mx.7facffa1.svg";